import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import LinkSite from '../../components/Panel/LinkSite/LinkSite';
import {Link} from 'react-router';
import urlBase from '../../url-base';
//import color from '@material-ui/core/colors/amber';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold',
      color : '#636363'
    },
    breadcrumb: {
      fontSize: 14,
      float: 'right',
      
    }
  };

const LinkSitePage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link  style={{ color : '#006ADB'}} to={urlBase.client + 'panel'}>Home</Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Link
          <span style={styles.tituloPagina}> Site</span>
        </h3>
        <LinkSite />
      </div>
    </Panel>

  );
};

export default LinkSitePage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/LinkSitePage.js
 **/